import { render, staticRenderFns } from "./ManageCompanies.vue?vue&type=template&id=1a5f1956&scoped=true&"
import script from "./ManageCompanies.vue?vue&type=script&lang=js&"
export * from "./ManageCompanies.vue?vue&type=script&lang=js&"
import style0 from "./ManageCompanies.vue?vue&type=style&index=0&id=1a5f1956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f1956",
  null
  
)

export default component.exports